export const DK = {
  bg0: '#010810', bg1: '#040D18', bg2: '#071422', bg3: '#0A1B2E',
  line: '#122840', line2: '#1A3550',
  teal: '#0FA3B1', tealBright: '#1FC8D6', tealDeep: '#0A7B86',
  s1: '#DCE4E8', s2: '#AEBCC3', s3: '#7C8E97', s4: '#4A6070',
  white: '#FFFFFF', text: 'rgba(255,255,255,.85)', muted: 'rgba(255,255,255,.45)',
  card: '#040D18', input: 'rgba(255,255,255,.05)', inputBorder: 'rgba(255,255,255,.1)',
}

export const LT = {
  bg0: '#F0F5F9', bg1: '#FFFFFF', bg2: '#EBF2F7', bg3: '#DDE9F0',
  line: 'rgba(10,32,40,.1)', line2: 'rgba(10,32,40,.14)',
  teal: '#0A8F9B', tealBright: '#0FA3B1', tealDeep: '#0A7B86',
  s1: '#0A2028', s2: '#3C545F', s3: '#6F858E', s4: '#A0B4BC',
  white: '#0A2028', text: 'rgba(10,32,40,.9)', muted: 'rgba(10,32,40,.5)',
  card: '#FFFFFF', input: 'rgba(10,32,40,.04)', inputBorder: 'rgba(10,32,40,.12)',
}

export const fmt = (v) => {
  if (!v) return '—'
  const n = Number(v)
  return isNaN(n) ? String(v) : n.toLocaleString('ru-RU')
}

export const fmtDate = (str) => {
  if (!str) return '—'
  try {
    return new Intl.DateTimeFormat('ru-RU', { day: '2-digit', month: 'long', year: 'numeric' }).format(new Date(str))
  } catch { return str }
}

export const fmtDateTime = (str) => {
  if (!str) return '—'
  try {
    return new Intl.DateTimeFormat('ru-RU', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' }).format(new Date(str))
  } catch { return str }
}

export const fmtMonth = (str) => {
  if (!str) return '—'
  try {
    return new Intl.DateTimeFormat('ru-RU', { month: 'long', year: 'numeric' }).format(new Date(str))
  } catch { return str }
}
